import BottomLeftPanel from "./BottomLeftPanel";

export default BottomLeftPanel;
